import { useState } from "react";
import { AlertCircle, LogIn } from "lucide-react";
import PasswordInput from "../../components/PasswordInput";
import faceLockImg from '../../assets/face-lock.svg';

/** Acceso al panel del negocio (dueño o profesional). */
function AdminLogin({ onLogin, loading }) {
    const [username, setUsername] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError("");
        try { await onLogin(username, password); } catch { setError("Usuario o contraseña incorrectos"); }
    };

    return (
        <form onSubmit={handleSubmit} className="cp-card cp-pub-login" autoComplete="off">
            <div className="cp-pub-login-head">
                <img src={faceLockImg} alt="" />
                <h2>Entrar al panel</h2>
                <p className="cp-muted">Solo para el negocio y su equipo.</p>
            </div>
            <div className="cp-form">
                <label className="cp-field"><span>Usuario</span><input type="text" className="cp-input" value={username} onChange={e => setUsername(e.target.value)} required autoFocus autoCapitalize="none" autoComplete="username" /></label>
                <label className="cp-field">
                    <span>Contraseña</span>
                    <PasswordInput className="cp-input" value={password} onChange={e => setPassword(e.target.value)} required autoComplete="current-password" />
                </label>
                {error && <div className="cp-note cp-note-danger"><AlertCircle size={16} /><div>{error}</div></div>}
                <button type="submit" className="cp-btn cp-btn-primary cp-btn-block" disabled={loading}>
                    {loading ? <><span className="cp-spin" /> Entrando…</> : <><LogIn size={16} /> Entrar</>}
                </button>
            </div>
        </form>
    );
}

export default AdminLogin;
